/**
 * Kiosk 4-inch Mockup Component
 * Wrapper for customizer that reads state from store and passes to unified KioskPreview
 * Based on Figma: node-id=3905-15248
 */

import React from 'react';
import { KioskUICustomization } from '../../types/kiosk-types';
import { KioskPreview } from './KioskPreview';
import { useKioskCustomizerStore } from '../../stores/kiosk-customizer-store';

interface KioskMockup4inchProps {
  config: KioskUICustomization;
}

/**
 * Kiosk 4-inch Mockup Component
 * Used in the customizer - reads pending state from store
 */
export function KioskMockup4inch({ config }: KioskMockup4inchProps) {
  // Get pending logo from store for live preview
  const pendingMedia4Logo = useKioskCustomizerStore((state) => state.pendingMedia4Logo);
  const pendingLogoUrl = pendingMedia4Logo?.previewUrl;

  // Get idle screen state from store
  const pendingMedia4IdleScreen = useKioskCustomizerStore((state) => state.pendingMedia4IdleScreen);
  const showIdleScreenInPreview = useKioskCustomizerStore((state) => state.showIdleScreenInPreview);

  // Use media4Logo if available, otherwise fall back to generic logo
  const media4Logo = config.icons.media4Logo || config.icons.logo;
  const logoSrc = pendingLogoUrl || media4Logo?.s3Url || media4Logo?.fallbackUrl;

  return (
    <KioskPreview
      config={config}
      pendingLogoUrl={logoSrc}
      pendingIdleScreen={pendingMedia4IdleScreen}
      showIdleScreen={showIdleScreenInPreview}
    />
  );
}
